import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { BanksQueryParams } from '../shared/interfaces/banks-query-params';
import { Summary } from '../shared/interfaces/bank-response.interface';
import { FxrateQueryParamsInterface } from '../shared/interfaces/fxrate-interface';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  readonly baseUrl = environment.url;
  readonly credUrl = environment.credUrl;
  constructor(public http: HttpClient) {}

  postData(serviceName: string, data: any) {
    return this.http.post(this.buildUrl(serviceName), data, { headers: this.getHeaders() });
  }

  getData(serviceName: string) {
    return this.http.get(this.buildUrl(serviceName), { headers: this.getHeaders() });
  }

  deleteData(serviceName: string, id: any) {
    // Include headers in the request
    const options = { headers: this.getHeaders() };
    return this.http.delete(`${this.buildUrl(serviceName)}/${id}`, options);
  }

  getCurrencyWithBank() {
    const baseUrl = environment.url + 'cash-transactions/currencies-banks-accounts';
    return this.http.get(baseUrl, { headers: this.getHeaders() });
  }

  getBankSummary(params: Partial<BanksQueryParams>): Observable<Summary> {
    return this.http.get<Summary>(`${environment.url}banks/summary`, {
      params: this.queryCleaner(params),
    });
  }

  getFxRateData(params: Partial<FxrateQueryParamsInterface>): Observable<any> {
    return this.http.get<any>(`${this.credUrl}fx-rates?`, {
      params: this.queryCleaner(params),
    });
  }
  getBankList(): Observable<any> {
    const baseUrl = this.baseUrl + 'banks';
    return this.http.get(baseUrl, { headers: this.getHeaders() });
  }

  deleteBankAccount(id: any) {
    const baseUrl = this.baseUrl + 'banks/accounts/' + id;
    return this.http.delete(baseUrl);
  }

  queryCleaner<T>(params: Partial<T>): { [key: string]: any } {
    for (const paramsKey in params) {
      if (!params[paramsKey as keyof T] && params[paramsKey as keyof T] !== 0) {
        delete (params as any)[paramsKey];
      }
    }
    return params;
  }

  queryCleanerBulk<T>(params: Partial<T>): { [key: string]: any } {
    for (const paramsKey in params) {
      if (!params[paramsKey as keyof T] || params[paramsKey as keyof T] === '~') {
        (params as any)[paramsKey] = null;
      }
    }
    return params;
  }

  getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
    });
  }

  buildUrl(serviceName: string): string {
    return `${this.baseUrl}${serviceName}`;
  }
}
